export default {
  pageTitleNewApply: 'Add Restocking Application',
  platformName: 'Marketplace',
  storeName: 'Store',
  defaultState: 'Normal',
  state: 'Status',
  shippingMethod: 'Method of first leg logistics',
  selfDelivery: 'Cross-Border Seller Self-Delivery',
  selfDelivery2: 'Cross-Border Seller Self-Delivery',
  noHeadTrip: 'Local Seller Self-Delivery',
  noHeadTrip2: 'Local Seller Self-Delivery',
  menuTitleMyApply: 'Manage Restocking Applications',
  menuTitleStockUpList: 'Manage Restocking Boxes',
  selectAuthorizedStore: 'Select authorized store',
  operate: 'Operate',
  select: 'Select',
  search: 'Search',
  productName: 'Product name',
  marketplaceSKU: 'Marketplace SKU',
  warehouseSKU: 'Warehouse SKU',
  warehouseSKUId: 'Warehouse SKU ID',
  sourceProductID: 'Source Product ID',
  productList: 'Candidate Product List',
  restockProductList: 'Restocking Product List',
  marketplaceSkuNumber: 'Marketplace SKU',
  productImage: 'Product Image',
  variant: 'Variant',
  inventory: 'Inventory',
  restockQty: 'Restock Qty',
  restockingQty: 'Restocking Qty',
  usePlatformLogistics: `Use platform's first leg logistics service`,
  total: 'Total',
  rows: 'rows',
  goTo: 'Go to',
  submit: 'Submit',
  filingTime: 'Filling Date',
  pleaseSelectWarehouse: 'Please select restocking warehouse',
  enterNumberCommas: 'Filling Warehouse SKU，multiple sku separated by English commas',
  warehouseSkuNumber: 'Warehouse SKU',
  spec: 'Variant',
  warehouseNumber: 'Warehouse ID',
  productCheck2: 'Qty is empty or format error！',
  present: 'Tips',
  presentText: 'Detected duplicate source product ID, do you want to treat them as the same product?',
  yes: 'Yes',
  no: 'No',
  pleaseSelectProduct: 'Select product to restock',
  productCheck1: 'Product',
  handleSuccess: 'Operation successful',
  handleError: 'Operation failed',
  inputText: 'The input value is',
  restockingWarehouse: 'Restocking Warehouse',
  applicationType: 'Application Type',
  localApplication: 'Local application',
  chinaApplication: 'China application',
  all: 'All',
  selectApplicationDate: 'Select application date range',
  applicationStatus: 'Application Status',
  inReview: 'In Review',
  approved: 'Approved',
  fullyApproved: 'Fully Approved',
  partiallyApproved: 'Partially Approved',
  rejected: 'Rejected',
  applicationID: 'Application ID',
  warehouseCountry: 'Warehouse Country',
  warehouseCIty: 'Warehouse City',
  varietiesOfSKU: 'Varieties of SKU',
  applicationStatus2: 'Application Status',
  applicationTime: 'Application Time',
  auditTime: 'Audit Time',
  applicant: 'Applicant',
  auditor: 'Auditor',
  details: 'Details',
  restockApplyDetail: 'Restocking Application Details',
  logisticsAccount: 'Logistics Account',
  appliedRestockQty: 'Applied Restock Qty',
  pendingOrderQty: 'Pending Order Qty',
  orderQty: 'Packing Qty',
  cancelApplication: 'Cancel Application',
  placeRestockingOrder: 'Place Restocking Order',
  placedRestockingOrders: 'Placed Restocking Orders',
  restockingOrderID: 'Restocking Box ID',
  warehouseName: 'Warehouse Name',
  restockingOrderQty1: 'Packed Qty',
  restockingOrderQty2: 'Restocking Order Qty',
  orderStatus: 'Box Status',
  restockStatus: 'Restock Status',
  effectiveTime: 'Effective Time',
  platformWaybill: 'Platform Waybill',
  firstMileCargo: 'First-mile Cargo',
  firstMileCargoWaybill: 'First-mile Cargo Waybill',
  areYouSureRestockOrder: 'Are you sure about this quantity for restocking order?',
  cancel: 'No',
  confirm: 'Yes',
  restockApplyOrderID: 'Application ID',
  myRestock: 'Restocking Box Details',
  printSheet: 'Print Box Details',
  confirmCancel: 'Are you sure to cancel?',
  applyCancel: 'Cancel Restocking Box',
  cancelApply: 'Cancel application',
  createRestock: 'Create Restocking Box',
  shipmentThreeLogistics: 'Dispatched to 3rd party International Logistics',
  localLogistics: 'Domestic shipping',
  trackNumberRemarks: 'Waybill number or notes',
  firstMileCargoMsg: 'First-mile Information',
  pleaseLogisticsCompanies: 'Select first-mile cargo',
  enterLogisticsNumber: 'Enter waybill',
  startShipment: 'Dispatch',
  historyStockOrders: 'Existing Boxes',
  nameInPartner: 'Store',
  enterRestockQty: 'Please input restocking qty',
  stockUspFailed: 'Creation failed! Please provide the shipping address of the store.Click here to jump to the address supplement interface.',
  selectStore: 'Select store',
  enterSkuId: 'Please input SKU ID',
  selectStoreAndEnter: 'Select store first',
  searchText: 'Search',
  exportText: 'Export',
  exportList: 'Export List',
  exportDetail: 'Export Details',
  selectProductsToExportDetail: 'Please select SKUs to export details',
  pendingShip: 'Pending Shipment',
  pendingTransitHubReceive: 'Pending Transit Hub Receipt',
  transitHubReceived: 'Transit Hub Received',
  pendingStockWhReceive: 'Pending Stock Warehouse Receipt',
  pendingStockWhShelve: 'Pending Stock Warehouse Shelving',
  goodsInTransit: 'In Transit',
  goodsPartCollected: 'Partially Received',
  goodsPartShelves: 'Partially Shelved',
  goodsCollected: 'Pending Shelving',
  shelved: 'Shelved',
  cancelled: 'Cancelled',
  pendingDispatch: 'Pending Dispatch',
  pendingTransit: 'Pending Transit Center Receipt',
  pendingReceived: 'Transit Center Receipt',
  shippedTransit: 'Shipped by Transit Center',
  ionFirstLegTransit: 'In First-leg Transit',
  clearingCustoms: 'Clearing Customs',
  pendingRestockingReceipt: 'Pending Restocking Receipt',
  pendingInventory: 'Pending Inventory',
  shipped: 'Shipped',
  canceled: 'Canceled',
  completed: 'Completed',
  Abnormal: 'Abnormal',
  selectEffectiveDate: 'Select Box Effective Date',
  manageFbkInventory: 'Manage FBK Inventory',
  addRestockingApplication: 'Add Restocking Application',
  selectWarehouse: 'Select Warehouse',
  warehouse: 'Warehouse',
  pleaseSelect: 'Please Select',
  fillingDate: 'Filling Date',
  totalInventory: 'Total Inventory',
  availableInventory: 'Sellable Inventory',
  unsellableInventory: 'Unsellable Inventory',
  unsellableInventoryQuantity: 'Unsellable Inventory Quantity',
  lockedInventory: 'Locked Inventory',
  unsalableReturnedInventory: 'Unsalable Returned Inventory',
  inventoryLog: 'Inventory Log',
  inventoryDetail: 'Inventory Detail',
  viewDetail: 'View Inventory Log',
  timeOfChange: 'Time of Change',
  logId: 'Log ID',
  inventoryAfterChange: 'Inventory After Change',
  inventoryMovement: 'Inventory Change',
  changeQty: 'Change Qty',
  changeType: 'Change Type',
  date: 'Date',
  timestamp: 'Timestamp',
  orderNumber: 'Order No.',
  remainingInventory: 'Remaining Inventory',
  startDateInclusive: 'Start Date (Incl.)',
  endDateInclusive: 'End Date (Incl.)',
  lastThirtyDays: 'Last 30 Days',
  selectCompleteDateRange: 'Please select both the start date and end date.',
  startDateCannotBeAfterEndDate: 'The start date cannot be later than the end date.',
  dateRangeCannotExceed365Days: 'The query time range cannot exceed 365 days.',
  noInventoryDetailRecords: 'No inventory detail records found.',
  inventoryRange: 'Inventory Range',
  dateApplyPlaceHolder: 'Select application date range',
  estimatedDispatchingDate: 'Estimated Dispatching Date',
  inTransitInventory: 'In-transit Inventory',
  inPlanInventory: 'In-plan Inventory',
  r30Sales: 'R30 Sales',
  r90Sales: 'R90 Sales',
  appliedQty: 'Applied Qty',
  orderableQty: 'Pending Packing Qty',
  approvedQty: 'Approved Qty',
  orderedQty: 'Packed Qty',
  boxPackedPieceQty: 'Packed Pieces',
  inboundQty: 'Inbound Qty',
  actualDispatchingDate: 'Actual Dispatching Date',
  estDispatchingDate: 'Est Dispatching Date',
  invitationName: 'Invitation Name',
  estimatedPlaceHolder: 'Select estimated Dispatching Date',
  remove: 'Remove',
  add: 'Add',
  added: 'Added',
  crossBoarderShippingType: 'Cross-boarder shipping type',
  expectedArrivalRestockingWarehouse: 'Expected arrival date at restocking warehouse',
  notes: 'Notes',
  selectDate: 'Select date',
  batchDispatch: 'Batch Dispatch',
  byAir: 'By Air',
  bySea: 'By Sea',
  dispatchBatchID: 'Dispatch Batch ID',
  application: 'Restocking Application ID',
  stockBoxNo: 'Box No.',
  expectedArrivalDate: 'Expected Arrival Date',
  noPendingDispatchBox: 'There is no pending dispatch box, you can not perform batch dispatching.',
  batchDispatchingTextOne: 'Are you sure you want to perform batch dispatching on the following',
  batchDispatchingTextTwo: 'restocking boxes?',
  batchDispatchingTextThree: 'Box ID',
  yesDispatchAllThem: 'Yes, dispatch all of them',
  noCancelBatchDispatch: 'No, cancel batch dispatching',
  alrightAware: 'Alright, I am aware',
  fillCargoNameWaybillNumber: 'Fill in cargo name and waybill number',
  customCode: 'Custom Code',
  customCodeName: 'Custom Code Name',
  customCodeNameCN: 'Product Name(CN)',
  customCodeAttribute: 'Custom Code Attribute',
  customDeclared: 'Custom Declared Value (CNY)',
  back: 'Back',
  confirmContinue: 'Confirm & Continue Dispatching',
  pleaseEnsureCustom: 'Please ensure that the customs information for the above items has been fully completed.',
  hsInfoEmptyCannotShip:
    'No product information was returned by hs-info, dispatching is currently unavailable.',
  confirmCustomRelated: 'Confirm custom related information of each restocking products',
  searchCustomsCode: 'Search Customs Code',
  sku: 'SKU',
  rejectReason: 'Reject Reason',
  activeProducts: 'Active Products?',
  skuId: 'SKU ID',
  listingId: 'Listing ID',
  multipleIdsCanSeparating: 'Multiple IDs can be input by separating them with commas.',
  existingFbkProducts: 'Existing FBK Products?',
  resetAll: 'Reset All',
  authorizedStore: 'Authorized Store',
  operation: 'Operation',
  inTransitInventoryTip: 'In-transit inventory refers to the number of items that have been dispatched but have not yet arrived at the restocking warehouse.',
  inPlanInventoryTip: 'In-plan inventory refers to the number of items that have been approved for stocking but have not yet been dispatched.',
  r30SalesTip: 'The quantity of sales delivered in the recent 30 days.',
  r90SalesTip: 'The quantity of sales delivered in the recent 90 days.',
  productSameWarehouseSkuBeen: 'Product with the same warehouse SKU have already been added to the stocking product list.',
  productSameSourceBeen: 'Product with the same source product id have already been added to the stocking product list.',
  someWarehouseOrSourceBatch: `In the products you've added, it's not allowed to have the same warehouse sku or source product id for multiple products. Please double-check before adding.`,
  sourceProductRefersTip: `Source product id refers to the seller's unique identifier for a product. Products with the same source product id are treated as the same item by the FBK warehouse, assigned the same warehouse SKU, and their inventory is shared. If two products on the marketplace share the same source product id and the inventory for the corresponding warehouse SKU is zero, both products on the marketplace will show as sold out.`,
  idAlreadyExistsInThisList: 'ID already exists in this list.',
  warehouseSkuSharingReminder: 'Warehouse SKU Sharing Reminder',
  theSourceProductFollowFbk: 'The source product id ({0}) you entered is associated with the following FBK products.',
  areYouSureShareInventory: 'Are you sure you want to share inventory with them?',
  shareInventory: 'Yes, share inventory',
  submitToApply: 'Submit to Apply',
  duplicate: 'Duplicate',
  close: 'Close',
  closed: 'Closed',
  areYouSureToClose: 'You can NOT create restocking box after you close this application. Are you sure to close?',
  yesContinueToClose: 'Yes, continue to close',
  noClose: 'No',
  productInfo: 'Product Info',
  batchOperation: 'Batch Operation',
  dispatch: 'Dispatch',
  singleDispatchDialogTitle: 'Dispatch',
  batchDispatchDialogTitle: 'Batch Dispatch',
  batchShipWarehouseMismatch:
    'The selected restocking boxes belong to different warehouses. Please dispatch them separately.',
  batchShipOrderNoMismatch:
    'Please dispatch boxes under different application orders separately.',
  batchShipLogisticsMismatch:
    'The selected boxes have inconsistent first-mile logistics methods. Please dispatch them separately.',
  batchDispatchStatusInvalid: 'The selected boxes include non-pending-shipment items. Please reselect.',
  batchShipInterfacePending: 'The batch dispatch API is pending and cannot be submitted yet.',
  batchShipOverLimit: 'You can dispatch up to {0} boxes at a time. '
    + 'Please reselect.',
  batchShipMissingOrderInfo: 'The selected boxes contain incomplete order information. '
    + 'Please reselect.',
  batchShipMissingCustomerOrderNo:
    'The selected boxes are missing the restocking application number. Please reselect.',
  batchShipMissingDetailList: 'The selected boxes contain incomplete product details. '
    + 'Batch dispatching is unavailable.',
  batchShipMissingSku: 'Box No. {0} is missing SKU information. Please check and try again.',
  shipSuccessTitle: 'Dispatch Success',
  shipFailedTitle: 'Dispatch Failed',
  singleShipSuccessMessage: 'Dispatch completed successfully.',
  singleShipFailedMessage: 'Dispatch failed.',
  batchShipFailedMessage: 'Batch dispatch failed.',
  batchShipSuccessMessage: 'Batch dispatch completed successfully.',
  shipFailedTip: 'Dispatch failed, please try again!',
  batchShipPartialSuccess: 'Shipment completed. Success: {success}, Failed: {failed}. Failed Box IDs: {list}',
  batchShipResultTitle: 'Shipment Result',
  pleaseEnsureSameRestockWarehouse: 'Please ensure that all selected boxes have the same restocking warehouse.',
  areYouPerformDispatchRestockBox: 'Are you sure you want to perform batch dispatching on the following {0} restocking boxes?',
  yourDispatchBatchId: 'Your dispatch batch id is',
  printLater: 'Print later',
  printNow: 'Print now',
  pleaseEnsureBoxApplicationType: 'Please ensure that all selected boxes have the same application type.',
  pleaseEnsureBoxLogistics: ' Please ensure that all selected boxes have the same first-mile logistics method.',
  onceTheApplicationClosed: 'Once the application is closed:',
  oneYouCanNotCreate: '1) you can',
  oneYouCanNotCreate2: ' NOT ',
  oneYouCanNotCreate3: 'create restocking box under this application;',
  twoQuantityRestored: '2) the quantity will',
  twoQuantityRestored2: 'not',
  twoQuantityRestored3: ' be restored to the related restock invitation plan.',
  areYouSureClose: 'Are you sure to close?',
  batchPrintBoxNo: 'Batch Print Box Number',
  batchPrintWarehouseNo: 'Batch Print Warehouse Number',
  batchPrintBatchNumber: 'Batch Print Batch Number',
  batchPrintBoxDetail: 'Batch Print Box Details',
  noInteraction: 'No interaction',
  pleaseSelectStockBox: 'Please select at least one stock box.',
  copySuccess: 'Copy Success',
  copyFailed: 'Copy Failed',
  copyNoContent: 'There is no content to copy for the time being',
  arrivalWarehouseAt: 'Arrival Warehouse Time',
  basicInfo: 'Basic Info',
  dispatchInfo: 'Dispatch Information',
  inputTip: 'Please enter',
  batchCreateRestock: 'Batch Create Boxes',
  batchCreateDialogTitle: 'Batch Create Boxes',
  batchCreatePrototypeTip: 'The batch create API is not ready yet. This dialog currently shows the page prototype only.',
  save: 'Save',
  batchCreateSku: 'SKU',
  pendingBoxQuantity: 'Pending Qty',
  quantityPerBox: 'Qty per Box',
  boxCount: 'Boxes',
  maxCreatableBoxes: 'Max Boxes',
  estimatedPackedQty: 'Planned Qty',
  remainingQtyAfterCreate: 'Remaining Qty',
  lastBoxQuantity: 'Last Box Qty',
  selectBatchCreateSku: 'Please select an SKU.',
  noPendingBoxQuantity: 'No items are available for batch box creation.',
  inputQuantityPerBox: 'Please enter qty per box.',
  quantityPerBoxExceeded: 'Exceeded the pending qty.',
  inputBoxCount: 'Please enter the number of boxes.',
  invalidBoxCount: 'Please adjust qty per box and box count.',
  boxCountExceeded: 'At most {0} restocking boxes can be created for this product.',
  batchCreateQuantityExceeded: 'Total qty cannot exceed the pending qty.',
  createStockTip: 'Packing needs to be operated according to the actual situation. If two cartons are actually packed, the corresponding system operation for packing needs to be carried out twice. Note: If the number of boxes is incorrect before shipment, it can be cancelled and repacked. If it cannot be modified after clicking "Ship", a new application is required. To avoid any inconsistency with the actual quantity packed, please first calculate the volume and confirm the actual number of cartons to be packed, and then operate the packing in the system to fill in the actual quantity of goods to be packed.',
  stockBox: {
    listTitle: 'Manage Restocking Boxes',
    detailTitle: 'Restocking Box Details',
    basicInfo: 'Basic Info',
    stockBoxId: 'Restocking Box ID',
    stockBoxNo: 'Box No.',
    batchNo: 'Batch No.',
    restockingApplicationOrder: 'Restocking Application',
    applicationNo: 'Restocking Application ID',
    restockStatus: 'Restock Status',
    status: 'Box Status',
    pieceQty: 'Piece Qty',
    boxCount: 'Box Count',
    shippingTime: 'Shipping Time',
    expectedArrivalDate: 'Expected Arrival Date',
    dispatchBatchId: 'Dispatch Batch ID',
    platformWaybill: 'Platform Waybill',
    effectiveTime: 'Effective Time',
    firstMileCarrier: 'First-mile Cargo',
    firstMileWaybill: 'First-mile Cargo Waybill',
    editDomesticTracking: 'Edit',
    editDomesticTrackingTitle: 'Edit Domestic Courier Information',
    domesticTrackingNoChange: 'You have not changed the tracking number',
    printDetail: 'Print Box Details',
    cancel: 'Cancel Restocking Box'
  }
}
